import images from '../images';

const site_updates = [
    {
        update: "layout and everything has changed! added status, currently, oc widget, soundcloud widget, and fav character widget.",
        date: "2026-10-2"
    },
    {
        update: "added a second page to the home screen! and also a site updates section! lol",
        date: "2026-09-28"
    }
]

const listItems = site_updates.map(update => (
    <div key={update.date}>
        <p>- <span id="updatedate">{update.date}</span> {update.update}</p>
    </div>
));

function SiteUpdates(props) {
    return (
      <>
        <div id="site-updates" className="status-wrapper">
            <div className="status-title"><p>⊹ site updates</p></div>
            <div className="status-details">
                <div id="site-updates-box" className='status-message'>
                {listItems}

                </div>
            </div>
        </div>
      </>
    );
  }

  export default SiteUpdates;